// NOTE: サーバ側の Karte::MAX_COMMENT_LENGTH に対応する。
// サーバでは GuardianMessage::MAX_OUTGOING_CONTENT_LENGTH（LINE 送信時の上限）から
// Karte::MAX_COMMENT_LENGTH → KarteTemplate#template へ定数を連鎖させているため、
// フロント側もカルテ本文・カルテコメント・テンプレート本文で同じ値を共有する。
// https://github.com/studyplus/boron/pull/6971
export const KarteContentMaxLength = 4000;
